// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-dropdown {
  min-width: calc(68 * var(--ds-unit));
  flex-direction: column;
  display: flex;
  box-shadow: 0 1px 8px #0000001a;
  width: auto !important;
}

.user-dropdown a, .user-dropdown a:hover {
  --tw-text-opacity: 1;
  color: rgb(69 89 166 / var(--tw-text-opacity));
}

.user-dropdown__header {
  padding-left: var(--base-sizes-8);
  padding-top: var(--base-sizes-2);
  padding-right: var(--base-sizes-4);
  padding-bottom: var(--base-sizes-8);
  flex: 1 1 0;
  align-items: flex-start;
  display: flex;
}

.user-dropdown__image {
  margin-top: var(--base-sizes-6);
  margin-right: var(--base-sizes-8);
  flex-shrink: 0;
}

.user-dropdown__header-right {
  flex-direction: column;
  flex: 1 1 0;
  justify-content: space-between;
  height: 100%;
  display: flex;
}

.user-dropdown__body {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  text-align: center;
  padding: var(--base-sizes-4);
  padding-bottom: var(--base-sizes-6);
  min-height: 8rem;
}

.user-dropdown__license-info {
  font-size: .75rem;
  line-height: 1rem;
}

.user-dropdown__license-info p {
  margin-bottom: var(--base-sizes-1);
}

.user-dropdown__license-info p:first-of-type {
  --tw-text-opacity: 1;
  color: rgb(38 65 131 / var(--tw-text-opacity));
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: var(--base-font-weight-semibold);
  margin-bottom: var(--base-sizes-2);
}

.user-dropdown__footer {
  padding: var(--base-sizes-4);
  justify-content: space-between;
  font-size: .75rem;
  line-height: 1rem;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/Header/UserDropdown/UserDropdown.css","webpack://./services/frontend/app/containers/App/Header/UserDropdown/UserDropdown.css"],"names":[],"mappings":"AADA;ECEE,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;EACnC,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf","sourcesContent":[".user-dropdown {\n\n  width: auto !important;\n\n  display: flex;\n\n  flex-direction: column;\n\n  min-width: calc(68 * var(--ds-unit));\n  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1)\n}\n\n.user-dropdown a {\n\n  --tw-text-opacity: 1;\n\n  color: rgb(69 89 166 / var(--tw-text-opacity))\n}\n\n.user-dropdown a:hover {\n\n  --tw-text-opacity: 1;\n\n  color: rgb(69 89 166 / var(--tw-text-opacity))\n}\n\n.user-dropdown__header {\n\n  padding-left: var(--base-sizes-8);\n\n  padding-top: var(--base-sizes-2);\n\n  padding-right: var(--base-sizes-4);\n\n  padding-bottom: var(--base-sizes-8);\n\n  display: flex;\n\n  flex: 1 1 0;\n\n  align-items: flex-start\n}\n\n.user-dropdown__image {\n\n  margin-top: var(--base-sizes-6);\n\n  margin-right: var(--base-sizes-8);\n\n  flex-shrink: 0\n}\n\n.user-dropdown__header-right {\n\n  display: flex;\n\n  flex: 1 1 0;\n\n  flex-direction: column;\n\n  justify-content: space-between;\n\n  height: 100%\n}\n\n.user-dropdown__body {\n\n  --tw-bg-opacity: 1;\n\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n\n  text-align: center;\n\n  padding: var(--base-sizes-4);\n\n  padding-bottom: var(--base-sizes-6);\n\n  min-height: 8rem\n}\n\n.user-dropdown__license-info {\n\n  font-size: 0.75rem;\n\n  line-height: 1rem\n}\n\n.user-dropdown__license-info p {\n\n  margin-bottom: var(--base-sizes-1)\n}\n\n.user-dropdown__license-info p:first-of-type {\n\n  --tw-text-opacity: 1;\n\n  color: rgb(38 65 131 / var(--tw-text-opacity));\n\n  font-size: 1rem;\n\n  line-height: 1.5rem;\n\n  font-weight: var(--base-font-weight-semibold);\n\n  margin-bottom: var(--base-sizes-2)\n}\n\n.user-dropdown__footer {\n\n  font-size: 0.75rem;\n\n  line-height: 1rem;\n\n  padding: var(--base-sizes-4);\n\n  display: flex;\n\n  justify-content: space-between\n}\n",".user-dropdown {\n  min-width: calc(68 * var(--ds-unit));\n  flex-direction: column;\n  display: flex;\n  box-shadow: 0 1px 8px #0000001a;\n  width: auto !important;\n}\n\n.user-dropdown a, .user-dropdown a:hover {\n  --tw-text-opacity: 1;\n  color: rgb(69 89 166 / var(--tw-text-opacity));\n}\n\n.user-dropdown__header {\n  padding-left: var(--base-sizes-8);\n  padding-top: var(--base-sizes-2);\n  padding-right: var(--base-sizes-4);\n  padding-bottom: var(--base-sizes-8);\n  flex: 1 1 0;\n  align-items: flex-start;\n  display: flex;\n}\n\n.user-dropdown__image {\n  margin-top: var(--base-sizes-6);\n  margin-right: var(--base-sizes-8);\n  flex-shrink: 0;\n}\n\n.user-dropdown__header-right {\n  flex-direction: column;\n  flex: 1 1 0;\n  justify-content: space-between;\n  height: 100%;\n  display: flex;\n}\n\n.user-dropdown__body {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n  text-align: center;\n  padding: var(--base-sizes-4);\n  padding-bottom: var(--base-sizes-6);\n  min-height: 8rem;\n}\n\n.user-dropdown__license-info {\n  font-size: .75rem;\n  line-height: 1rem;\n}\n\n.user-dropdown__license-info p {\n  margin-bottom: var(--base-sizes-1);\n}\n\n.user-dropdown__license-info p:first-of-type {\n  --tw-text-opacity: 1;\n  color: rgb(38 65 131 / var(--tw-text-opacity));\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: var(--base-font-weight-semibold);\n  margin-bottom: var(--base-sizes-2);\n}\n\n.user-dropdown__footer {\n  padding: var(--base-sizes-4);\n  justify-content: space-between;\n  font-size: .75rem;\n  line-height: 1rem;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
